import React from 'react';
import { ThemeProvider } from 'fronton-react';
import { StoreContext } from 'storeon/react';
import { Baseline } from 'common/components';
import { ConsultationSection, ConsultationSectionProps } from 'remotes/consultation-section';
import { RemoteProps } from './widgets-types';

type ConsultationSectionRemoteProps = ConsultationSectionProps & Omit<RemoteProps, 'router'>;

export const ConsultationSectionRemote: React.FC<ConsultationSectionRemoteProps> = ({ store, ...props }) => (
  <ThemeProvider>
    <Baseline>
      <StoreContext.Provider value={store}>
        <ConsultationSection {...props} />
      </StoreContext.Provider>
    </Baseline>
  </ThemeProvider>
);
